import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AuthGuard from './AuthGuard';
import { loginPath, homePath } from '../constants/paths';

// 懒加载页面组件以实现代码分割
const Login = lazy(() => import('../pages/Login'));
const StoreAuthorizationPage = lazy(() => import('../pages/StoreAuthorization'));
const App = lazy(() => import('../App'));

// 加载中组件
const LoadingFallback = () => (
  <div className="h-screen w-full flex items-center justify-center bg-gray-50">
    <div className="text-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-red mx-auto mb-4"></div>
      <p className="text-gray-500">Loading...</p>
    </div>
  </div>
);

const AppRouter: React.FC = () => {
  return (
    <BrowserRouter>
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          {/* 登录页 - 不需要认证 */}
          <Route path={loginPath} element={<Login />} />

          {/* Store Authorization */}
          <Route
            path="/store-authorization"
            element={
              <AuthGuard>
                <StoreAuthorizationPage />
              </AuthGuard>
            }
          />

          {/* 受保护的路由 - 需要登录 */}
          <Route
            path="/*"
            element={
              <AuthGuard>
                <App />
              </AuthGuard>
            }
          />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default AppRouter;
